package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.SteamdeckSimpleIcons: ImageVector
    get() {
        if (_steamdeckSimpleIcons != null) {
            return _steamdeckSimpleIcons!!
        }
        _steamdeckSimpleIcons = Builder(name = "SteamdeckSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(9.00f, 0.0f)
                verticalLineToRelative(4.31f)
                curveToRelative(4.24f, 0.0f, 7.69f, 3.45f, 7.69f, 7.69f)
                reflectiveCurveToRelative(-3.45f, 7.69f, -7.69f, 7.69f)
                lineTo(9.00f, 24.0f)
                curveToRelative(6.62f, 0.0f, 12.0f, -5.38f, 12.0f, -12.0f)
                reflectiveCurveToRelative(-5.38f, -12.0f, -12.0f, -12.0f)
                close()
                moveTo(9.00f, 6.01f)
                curveToRelative(-3.31f, 0.0f, -6.0f, 2.69f, -6.00f, 6.0f)
                arcToRelative(6.00f, 6.00f, 0.0f, true, false, 6.00f, -6.0f)
                close()
            }
        }
        .build()
        return _steamdeckSimpleIcons!!
    }

private var _steamdeckSimpleIcons: ImageVector? = null
